module.exports = __webpack_public_path__ + "static/outoftheflame-5f3a937dc7a6aa68d1ae3c9d31b033be.jpg";